<script>
export default {
  name: "FooterPage"
}
</script>

<template>
  <div></div>
</template>

<style scoped>

</style>